var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.081 33.07C-.516 25.73.156 16.345 5.75 9.721 11.342 3.1 20.48.865 28.486 4.17m9.288 7.842a19.807 19.807 0 01-1.671 23.345 19.811 19.811 0 01-15.154 7.062c-2.542 0-5.115-.49-7.58-1.505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.382 5.861l4.11-1.707L26.78.043M17.474 39.14l-4.109 1.71 1.71 4.109m11.109-17.704a6.432 6.432 0 01-10.762-4.752 6.43 6.43 0 016.432-6.43c1.667 0 3.186.632 4.33 1.674m-12.929 2.805h8.35m-8.35 3.9h8.35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidity);
export default __webpack_public_path__ + "static/media/liquidity.4f2693603f42eb4fb887aecdcb112fe4.svg";
export { ForwardRef as ReactComponent };